module.exports = __webpack_public_path__ + "media/images/signup-1-4cdd623ed6d9d531b42bd7082489a48e.svg";